import { FEATURE_FLAGS, useIsFeatureEnabled } from "@/feature-flags"
import { useTransportOrganizationContext } from "@/transport"
import { useOptionalWorkspaceContext } from "@/workspaces/scope"

import { ChatNotebookAction } from "../components/ChatNotebookAction"

export function SofiaNotebookActionRoute() {
  const enabled = useIsFeatureEnabled(FEATURE_FLAGS.SOFIA_NOTEBOOKS)
  const { isAuthLoaded, isOrganizationSynced, organizationSlug } =
    useTransportOrganizationContext()
  const workspaceContext = useOptionalWorkspaceContext()
  const workspaceId =
    workspaceContext?.currentWorkspace?.id ??
    workspaceContext?.routeWorkspaceId ??
    null
  return enabled &&
    isAuthLoaded &&
    isOrganizationSynced &&
    organizationSlug &&
    workspaceId ? (
    <ChatNotebookAction
      workspaceId={workspaceId}
      organizationSlug={organizationSlug}
    />
  ) : null
}
